export class HighlightAnnotation {
    constructor(type, canvasListener, highlightElement, selection, options, zoomOptions, orientation, id) {
        this.id = id
        this.type = type
        this.options = options
        this.zoomOptions = zoomOptions
        this.canvasListener = canvasListener
        this.highlightElement = highlightElement
        this.selection = selection
        this.selected = false
        this.hlhitbox = null
        this.newHLDivs = []
        this.HLlines = [[]]
        this.setOptionsDefaults()
        this.zoomMemory = []
        this.createdAtZoomLevel = 0
        this.currentScale = 1.0
        this.orientation = orientation
    }

    getType() {
        return this.type
    }

    setOptionsDefaults() {
        if (this.options.color == null || this.options.color == "" || this.options.color.length != 7) {
            this.options.color = "#ffff00"
        }
        
        if (this.highlightElement == null) {
            if (this.highlightElement == null) {
                this.highlightElement = document.createElement('div')
                this.highlightElement.className = "highlights"
                this.highlightElement.style.position = "absolute"
                var cBound = this.canvasListener.getBoundingClientRect()
                this.highlightElement.style.height = cBound.height + "px"
                this.highlightElement.style.width = cBound.width + "px"
                this.highlightElement.style.top = 0 + "px"
                this.highlightElement.style.left = 0 + "px"
                this.highlightElement.style.pointerEvents = "none"
                // this.highlightElement.style.border = '1px solid black'
                this.canvasListener.parentNode.appendChild(this.highlightElement)
            }
        }
    }

    showHighlight(loaded = false, redo = false) {
        this.newHLDivs = []
        let cBound = this.canvasListener.getBoundingClientRect()
        if (this.selection != null && this.selection.length > 0) {
            for (var rect of this.selection) {
                if (rect.width == 0 || rect.height == 0) {
                    break;
                }
                var el = document.createElement('div')
                el.style.position = "absolute"
                el.style.backgroundColor = this.options.color.length != 9 ? this.options.color + '55' : this.options.color
                if (redo == true || loaded == true) {
                    if (this.zoomOptions.zoom != 0) this.applyScale()
                    el.style.top = Math.floor(rect.top - this.options.pageTopOffset) + "px"
                    el.style.left = Math.floor(rect.left - this.options.pageOffset) + "px"
                } else {
                    this.createdAtZoomLevel = this.zoomOptions.zoom
                    this.createdAtOrientation = this.orientation
                    el.style.top = Math.floor(rect.top - cBound.top) + "px"
                    el.style.left = Math.floor(rect.left - cBound.left) + "px"
                }
                el.style.width = rect.width + "px"
                el.style.height = rect.height + "px"
                el.style.pointerEvents = "none"
                this.highlightElement.appendChild(el)
                this.newHLDivs.push(el)

            }
        }
    }

    drawHighlight(loaded, redo) {
        this.showHighlight(loaded, redo)
        if (loaded == true) {
            this.HLlines = []
            for (var hl of this.newHLDivs) {
                this.HLlines.push([hl])
            }
        } else if (this.newHLDivs.length > 0) {
            var HLlinesWidths = []
            var lineIndex = 0
            var firstHLCBound = this.newHLDivs[0].getBoundingClientRect()
            var firstChild = this.newHLDivs[0]
            var previousChild = null
            if (this.orientation == "portrait") {
                for (let child of this.newHLDivs) {
                    let childCBound = child.getBoundingClientRect()
                    if (childCBound.top + childCBound.height < firstHLCBound.top + firstHLCBound.height + 5 && childCBound.top + childCBound.height > firstHLCBound.top + firstHLCBound.height - 5 && childCBound.width != 0) { // child is on same line
                        this.HLlines[lineIndex].push(child)
                        previousChild = child
                    } else if (childCBound.width != 0 && previousChild != null) { // child is on new line
                        HLlinesWidths.push([])
                        HLlinesWidths[lineIndex].push(firstHLCBound.width + (previousChild.getBoundingClientRect().left - (firstHLCBound.left + firstHLCBound.width)) + previousChild.getBoundingClientRect().width)
                        lineIndex += 1
                        this.HLlines.push([])
                        this.HLlines[lineIndex].push(child)
                        firstHLCBound = child.getBoundingClientRect()
                        firstChild = child
                    }
                }
                HLlinesWidths.push([])
                if (firstHLCBound.width != 0) {   
                    if (this.HLlines.at(-1).length != 1) {
                        HLlinesWidths[lineIndex].push(firstHLCBound.width + (previousChild.getBoundingClientRect().left - (firstHLCBound.left + firstHLCBound.width)) + previousChild.getBoundingClientRect().width)
                    } else {
                        HLlinesWidths[lineIndex].push(firstHLCBound.width)
                    }
                    this.selection = []
                    for (var [i, line] of this.HLlines.entries()) {
                        var firstChild = line.at(0)
                        firstChild.style.width = HLlinesWidths[i] + "px"
                        var a = JSON.parse(JSON.stringify(line[0].getBoundingClientRect()))
                        a.offsetTop = line[0].offsetTop
                        a.offsetLeft = line[0].offsetLeft
                        this.selection.push(a)
                        for (var childIndex = line.length-1; childIndex > 0 ; childIndex--) {
                            line[childIndex].remove()
                            line[childIndex] = null
                            line.splice(childIndex, 1)
                        }
                        line.splice(1, line.length-1)
                    }
                }
            } else if (this.orientation == "landscape") {
                for (let child of this.newHLDivs) {
                    let childCBound = child.getBoundingClientRect()
                    if (childCBound.left + childCBound.width < firstHLCBound.left + firstHLCBound.width + 5 && childCBound.left + childCBound.width > firstHLCBound.left + firstHLCBound.width - 5 && childCBound.height != 0) { // child is on same line
                        this.HLlines[lineIndex].push(child)
                        previousChild = child
                    } else if (childCBound.height != 0 && previousChild != null) { // child is on new line
                        HLlinesWidths.push([])
                        HLlinesWidths[lineIndex].push(firstHLCBound.height + (previousChild.getBoundingClientRect().top - (firstHLCBound.top + firstHLCBound.height)) + previousChild.getBoundingClientRect().height)
                        lineIndex += 1
                        this.HLlines.push([])
                        this.HLlines[lineIndex].push(child)
                        firstHLCBound = child.getBoundingClientRect()
                        firstChild = child
                    }
                }
                HLlinesWidths.push([])
                if (firstHLCBound.height != 0) {   
                    if (this.HLlines.at(-1).length != 1) {
                        HLlinesWidths[lineIndex].push(firstHLCBound.height + (previousChild.getBoundingClientRect().top - (firstHLCBound.top + firstHLCBound.height)) + previousChild.getBoundingClientRect().height)
                    } else {
                        HLlinesWidths[lineIndex].push(firstHLCBound.height)
                    }
                    this.selection = []
                    for (var [i, line] of this.HLlines.entries()) {
                        var firstChild = line.at(0)
                        firstChild.style.height = HLlinesWidths[i] + "px"
                        
                        var a = JSON.parse(JSON.stringify(line[0].getBoundingClientRect()))
                        a.offsetTop = line[0].offsetTop
                        a.offsetLeft = line[0].offsetLeft
                        this.selection.push(a)
                        for (var childIndex = 1; childIndex < line.length; childIndex++) {
                            line[childIndex].remove()
                            line[childIndex] = null
                            line.splice(childIndex, 1)
                        }
                        line.splice(1, line.length-1)
                    }
                }
            }
        }
    }

    shrinkLeft(index, newLeft) {
        this.HLlines[index][0].style.left = (newLeft - this.options.pageOffset) + "px"
        this.HLlines[index][0].style.width = (this.selection[0].width - (newLeft - this.selection[0].left)) + "px"
        // update selection
        this.selection[index] = JSON.parse(JSON.stringify(this.HLlines[index][0].getBoundingClientRect()))
    }

    shrinkRight(index, newRight) {
        this.HLlines[index][0].style.width = (this.selection[index].width - ((this.selection[index].left + this.selection[index].width) - newRight)) + "px"
        // update selection
        this.selection[index].width = (this.selection[index].width - ((this.selection[index].left + this.selection[index].width) - newRight))
    }

    shrinkDown(index, newTop) {
        this.HLlines[index][0].style.top = (newTop - this.options.pageTopOffset) + "px"
        this.HLlines[index][0].style.height = (this.selection[0].height - (newTop - this.selection[0].top)) + "px"
        // update selection
        this.selection[index] = JSON.parse(JSON.stringify(this.HLlines[index][0].getBoundingClientRect()))
    }

    shrinkUp(index, newBottom) {
        this.HLlines[index][0].style.height = (this.selection[index].height - ((this.selection[index].top + this.selection[index].height) - newBottom)) + "px"
        // update selection
        this.selection[index].height = (this.selection[index].height - ((this.selection[index].top + this.selection[index].height) - newBottom))
    }

    splitAnnotationHorizontal(index, newLeft, newRight, currentTop) {
        var returnVal = {
            selection: [{
                bottom: currentTop + this.selection[index].height,
                height: this.selection[index].height,
                left: newRight + 1,
                right: (newRight + 1) + this.selection[index].width - (newLeft - this.selection[index].left) - (newRight - newLeft),
                top: currentTop,
                width: this.selection[index].width - (newLeft - this.selection[index].left) - (newRight - newLeft),
                x: newRight + 1,
                y: currentTop
            }],
            options: this.options,
            zoomOptions: this.zoomOptions
        }
        // then shrink left annotation with a shrinkRight (post-overlap)
        this.shrinkRight(index, newLeft)
        return returnVal
    }
    
    splitAnnotationVertical(index, newTop, newBottom) {
        var newHeight = this.selection[index].height - (newBottom - newTop) - (this.selection[index].bottom - newBottom)
        var returnVal = {
            selection: [{
                bottom: newTop,
                height: newHeight,
                left: this.selection[index].left,
                right: this.selection[index].right,
                top: newTop - newHeight,
                width: this.selection[index].width,
                x: this.selection[index].left,
                y: newTop - newHeight
            }],
            options: this.options,
            zoomOptions: this.zoomOptions
        }
        // then shrink left annotation with a shrinkRight (post-overlap)
        this.shrinkDown(index, newBottom)
        return returnVal
    }

    removeAnnotation(index) {
        if (index == null) { // remove all
            for (var hl of this.HLlines) {
                hl[0].remove()
                hl[0] = null
                hl.splice(0, 1)
            }
        } else {
            if (this.HLlines != null && this.HLlines.length > 0 && this.HLlines[index] != null && this.HLlines[index].length > 0) {
                this.HLlines[index][0].remove()
                this.HLlines[index][0] = null
                this.HLlines[index].splice(0, 1)
            }
            this.HLlines.splice(index, 1)
            this.selection.splice(index, 1)
        }
    }

    fixed(num, fix = 1) {
        return Number(parseFloat(num).toFixed(fix))
    }

    redraw() {
        let scaledWrapper = this.canvasListener
        let scaledContent = this.highlightElement
        
        var outerWidth = scaledWrapper.offsetWidth
        var outerHeight = scaledWrapper.offsetHeight
        var innerWidth = scaledContent.offsetWidth
        var innerHeight = scaledContent.offsetHeight

        var scaleWidth = outerWidth / innerWidth
        var scaleHeight = outerHeight / innerHeight

        var scale = Math.min(scaleWidth, scaleHeight)

        scaledContent.style.transformOrigin = 'top left'
        scaledContent.style.transform = `scale(${scale})`

        for (var [index, highlight] of this.HLlines.entries()) {
            if (highlight.length > 0)
                this.selection[index] = JSON.parse(JSON.stringify(highlight[0].getBoundingClientRect()))
        }
    }

    applyScale() {
        var newWidth = this.highlightElement.offsetWidth + ((this.zoomOptions.pageWidthIncreasePerZoom) * this.zoomOptions.zoom)
        var newTop = (newWidth / this.canvasListener.offsetWidth) * this.canvasListener.offsetHeight

        this.highlightElement.style.width = newWidth + "px"
        this.highlightElement.style.height = newTop + "px"

        this.redraw()
    }

    hide() {
        this.highlightElement.style.display = "none"
    }

    show() {
        this.highlightElement.style.display = "unset"
    }

    drawHitbox() {
        // var el = document.createElement('span')
        // el.style.border = "1px dashed blue"
        // el.style.zIndex = 500
        // el.classList.add("selected")

        // el.style.left = this.selection[0].left
        // el.style.top = this.selection[0].top
        // el.width = Math.max(...this.selection.map(s => s.width))
        // el.height = this.selection.reduce((n, {height}) => n + height, 0)
        // el.className("HLHitbox")

        // this.highlightElement.appendChild(el)
        // this.hlhitbox = el
        // this.selected = true
    }

    removeHitbox() {
        // this.hlhitbox.remove()
        // this.hlhitbox = null
    }


}
